import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import "./Title.css";

var ModalTitle = function ModalTitle(_a) {
  var children = _a.children,
      className = _a.className;
  return React.createElement("h1", {
    className: cx('nx-modals-title', className)
  }, children);
};

ModalTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
export default ModalTitle;

try {
  // @ts-ignore
  Title.__docgenInfo = {
    "description": "",
    "displayName": "Title",
    "props": {
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}